module.exports = __webpack_public_path__ + "static/media/usg-single-cube.e402b443.png";